import 'inventory-listing/components/ListingFilters/Components/ListingFiltersCategory/ListingFiltersCategory.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import FiltersCategory from 'inventory-listing/components/ListingFilters/Components/ListingFiltersCategory/Category.jsx';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

class ListingFiltersCategory extends React.Component {
    constructor(props) {
        super(props);
        this.changeCategory = this.changeCategory.bind(this);
        this.mapColanders = this.mapColanders.bind(this);
    }

    mapColanders(colanders) {
        return colanders.map((colander) => {
            return new MetaDataModel({
                code: colander.slug,
                label: colander.displayName,
                isSelected: colander.slug === this.props.selectedColander,
                url: colander.urlMapping,
            });
        });
    }

    changeCategory(selectedCode) {
        this.props.updateVehicleCriteria(selectedCode, 'colanderSlug');
        AnalyticsService.ga4Trigger(TAGS.LAYER_NAVIGATION__FILTERS(WindowProxy.location().pathname, 'category'));
    }

    render() {
        if (this.props.colanders.length <= 1) {
            return null;
        }
        const metaDataModels = this.mapColanders(this.props.colanders);

        const filtersCategories = metaDataModels.map((cat) => (
            <FiltersCategory key={cat.code} colander={cat} changeCategory={this.changeCategory} />
        ));

        return (
            <div className="listing-used-filters-bloc listing-used-filters-category">
                <div className="listing-used-filters-title sr-text is-bold">{LocaleService.t('FILTERS.CATEGORY')}</div>
                <ul className="listing-used-filters-category-list">{filtersCategories}</ul>
            </div>
        );
    }
}

ListingFiltersCategory.defaultProps = {
    colanders: [],
};

ListingFiltersCategory.propTypes = {
    colanders: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            slug: PropTypes.string,
        })
    ),
    updateVehicleCriteria: PropTypes.func.isRequired,
    selectedColander: PropTypes.string.isRequired,
};

ListingFiltersCategory.displayName = 'ListingFiltersCategory';

export default ListingFiltersCategory;
